import React from 'react'
import { useForm } from 'react-hook-form'
import Button from '../../components/button'
import Headline5 from '../../components/headings/Headline5'
import Modal from '../../components/modal'
import { MultiDropDownInput } from '../../wrappers/multiselectInput'
import { DropDownInput } from '../../wrappers/selectInput'

export type CompanyTimesheetFilterForm = {
    companyName?: any;
    registrationApproval?: string;
    leavesAllowed?: string;
    carryForward?: string;
}

interface props {
    clickHandler: any;
    defaultValues?: any;
    onClose: any;
    companyNames: any;
}

const CompanyTimesheetFilter: React.FC<props> = ({
    clickHandler,
    defaultValues,
    onClose,
    companyNames
}) => {

    const formOptions = {
    //     defaultValues: useMemo(() => {
    //     return defaultValues;
    // }, [defaultValues])
    };
    
    const { register, handleSubmit, control } =
    useForm<CompanyTimesheetFilterForm>(formOptions);

    const onSubmit = (data: any) => {
   
        let finalData = {
            "customerId": data.companyName,
            "approvalNeeded": data.registrationApproval,
            "leaves": data.leavesAllowed,
            "leavesCarryForward": data.carryForward
        }
       clickHandler(finalData)
  }
 

  return (
      <Modal title='companysheetFilter' size='medium' onClose={onClose}>
          <form>
          <Headline5>Companysheet Filter</Headline5>
        <div className="half-form-wrap1">
          <div className="form-group">
              <label className="lablel">Company Name</label>
              <MultiDropDownInput<CompanyTimesheetFilterForm>
                  name='companyName'
                  data={companyNames}
                  register={register}
                  control={control}
                  textField='companyName'
                  dataItemKey='companyId'
              />
                  </div>
              </div>
        <div className="half-form-wrap">
          <div className="form-group">
              <label className="lablel">Time sheet approval needed ?</label>
              <DropDownInput<CompanyTimesheetFilterForm>
                  name='registrationApproval'
                  register={register}
                  control={control}
                  textField='name'
                  dataItemKey='id'
                  data={[{name: 'Yes', id: 0},{name: 'No', id: 1}]}
              />
          </div>      
          <div className="form-group">
              <label className="lablel">Allow leaves carry forward ?</label>
              <DropDownInput<CompanyTimesheetFilterForm>
                  name='carryForward'
                  data={[{name: 'Yes', id: 0},{name: 'No', id: 1}]}
                  register={register}
                  control={control}
                  textField='name'
                          dataItemKey='id'
                          
              />
                  </div>
              </div>
              <div className="half-form-wrap">
          <div className="form-group">
              <label className="lablel">Allow leaves ?</label>
              <DropDownInput<CompanyTimesheetFilterForm>
                  name="leavesAllowed"
                  register={register}
                  control={control}
                  textField='name'
                  dataItemKey='id'
                  data={[{name: 'Yes', id: 0},{name: 'No', id: 1}]}
              />
          </div>      
          </div>
        <div className="popupAction">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit(onSubmit)}>
            Apply Filter
          </Button>
        </div>
      </form>
    </Modal>
  )
}

export default CompanyTimesheetFilter